export const getConfigurationEAPSettingsListQuery = () => `
  query getDeviceConfigurationEAPSettingsList {
      eapSettings {
        id
        name
        ssid
        cipherType
        eapType
        username
        anonymousUser
        caCertificateFilename
        clientCertificateFilename
        clientPrivateKeyFilename
        assignedDeviceCount
      }
  }
`;

export const getEapSettingByIdQuery = () => `
  query getEapSettingById($id: ID!) {
      eapSetting(id: $id) {
        id
        name
        ssid
        cipherType
        eapType
        username
        anonymousUser
        caCertificateFilename
        clientCertificateFilename
        clientPrivateKeyFilename
        assignedDeviceCount
      }
  }
`;

export const deleteEapSettingsMutation = () => `
  mutation deleteEapSettings($ids: [UUID!]!) {
      deleteEapSettings(ids: $ids)
  }
`;

export const getMissingEapCertificatesQuery = () => `
  query getMissingEapCertificates($certs: MissingCertificatesInput!) {
      getMissingEapCertificates(certs: $certs) {
          caCertificateFilenames
          clientCertificateFilenames
          privateKeyFilenames
      }
  }
`;
